import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAdminLoginMutation } from '../../api/authApi';
import { AlertUtils } from '../../../../shared/utils/alert';

export function useLoginHook() {
  const [formData, setFormData] = useState({ email: '', password: '' });
  const [showPassword, setShowPassword] = useState(false);
  const [login, { isLoading }] = useAdminLoginMutation();
  const navigate = useNavigate();

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) =>
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!formData.email || !formData.password) {
      AlertUtils.warning('Validation Error', 'Please fill in all fields');
      return;
    }

    try {
      const response = await login(formData).unwrap();
      localStorage.setItem('admin_token', response.data.token);
      localStorage.setItem('admin_user', JSON.stringify(response.data.admin));

      const userRole = response.data.admin?.role || 'Admin';

      if (userRole === 'Admin' || userRole === 'SuperAdmin' || userRole === 'member') {
        navigate('/admin/dashboard');
      } else {
        AlertUtils.show('Portal Ready', `Welcome! The ${userRole.replace('_', ' ')} Dashboard is currently under development.`, 'info');
        navigate('/');
      }
    } catch (err: any) {
      AlertUtils.error('Authentication Failed', err?.data?.message || err?.message || 'Invalid email or password.');
    }
  };

  return {
    formData,
    showPassword,
    isLoading,
    setShowPassword,
    handleChange,
    handleSubmit,
  };
}
